export enum EsnSubscriptionBulkAction {
  ManageRecipients = "Manage Recipients",
}
